import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}



Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home,
        redirect: "index",
        children: [
            {
                path: "index",
                name: "iristarHome",
                component: (resolve) => require(["@/views/home/HomeInfo"], resolve),
            },
            {
                path: "iristar-core",
                name: "iristarCore",
                component: (resolve) => require(["@/views/core/iristarCore"], resolve),
            },
            {
                path: "iristar-product",
                name: "iristarProduct",
                component: (resolve) => require(["@/views/product/iristarProduct"], resolve),
            },
            {
                path: "iristar-service",
                name: "iristarService",
                component: (resolve) => require(["@/views/product/iristarService"], resolve),
            },
            {
                path: "product-details/:index",
                name: "ProductDetial",
                component: (resolve) => require(["@/views/product/details"], resolve),
            },
            {
                path: "service-details/:index",
                name: "ServiceDetial",
                component: (resolve) => require(["@/views/service/details"], resolve),
            },
            {
                path: "iristar-software",
                name: "iristarSoftware",
                component: (resolve) => require(["@/views/product/iristarSoftware"], resolve),
            },
            {
                path: "iristar-aisoftware",
                name: "iristarAiSoftware",
                component: (resolve) => require(["@/views/product/iristarAiSoftware"], resolve),
            },
            {
                path: "iristar-Module",
                name: "iristarModule",
                component: (resolve) => require(["@/views/product/iristarModule"], resolve),
            },
            {
                path: "iristar-product-center",
                name: "irisarProductSoftware",
                component: (resolve) => require(["@/views/product/irisarSoftware"], resolve),
            },

            {
                path: "module-details/:index",
                name: "moduleDetial",
                component: (resolve) => require(["@/views/product/moduleDetail"], resolve),
            },
            {
                path: "iristar-solution",
                name: "iristarProgramme",
                component: (resolve) => require(["@/views/solution/iristarSolution"], resolve),
            },
            {
                path: "solution-details/:index",
                name: "solutionDetails",
                component: (resolve) => require(["@/views/solution/details"], resolve),
            },
            {
                path: "iristar-solution-factory",
                name: "SmartFactory",
                component: (resolve) => require(["@/views/solution/factory"], resolve),
            }, {
                path: "iristar-solution-swzy",
                name: "SmartFactory",
                component: (resolve) => require(["@/views/solution/IristarSwzy"], resolve),
            },
            {
                path: "iristar-news",
                name: "iristarNews",
                component: (resolve) => require(["@/views/news/iristarNews"], resolve),
            },
            {
                path: "news-details/:index",
                name: "newsDetails",
                component: (resolve) => require(["@/views/news/details"], resolve),
            },
            {
                path: "iristar-about",
                name: "iristarAbout",
                component: (resolve) => require(["@/views/about/iristarAbout"], resolve),
            },
            {
                path: "iristar-joinUs",
                name: "iristarJoinUs",
                component: (resolve) => require(["@/views/joinUs/iristarJoinUs"], resolve),
            },
            {
                name: "404",
                path: "404",
                component: (resolve) => require(["@/views/404/404"], resolve),
            },
        ],
    },
    {
        path: "*",
        redirect: "/404",
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;
